module.exports = __webpack_public_path__ + "logo_equals_inicial.svg?2f21141425abb979746f279fc112e316";


//////////////////
// WEBPACK FOOTER
// ./client/assets/logos_equals/logo_equals_inicial.svg
// module id = 1139
// module chunks = 0